const ContactBar = () => (
  <>
    <style>{`
      /* ── Global Contact Bar ── */
      .gcb {
        position: fixed;
        top: 55px;
        left: 0;
        width: 100%;
        z-index: 1040;
        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        padding: 5px 16px;
        height: 32px;
        box-sizing: border-box;
      }

      .gcb a {
        color: #fff;
        text-decoration: none;
        font-weight: 600;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 6px;
        white-space: nowrap;
      }

      .gcb a:hover { opacity: 0.85; }
      .gcb .gcb-sep { color: rgba(255,255,255,0.5); font-size: 14px; }
      .gcb .gcb-hours {
        font-size: 10px;
        color: rgba(255,255,255,0.9);
        border-left: 1px solid rgba(255,255,255,0.4);
        padding-left: 8px;
        white-space: nowrap;
      }

      /* Desktop: hidden — numbers appear inside each page's own navbar */
      @media (min-width: 992px) {
        .gcb { display: none !important; }
      }

      /* Mobile adjustments */
      @media (max-width: 767px) {
        .gcb { gap: 14px; }
      }

      @media (max-width: 360px) {
        .gcb { gap: 8px; padding: 5px 8px; }
        .gcb a { font-size: 13px; gap: 4px; }
        .gcb svg { width: 14px !important; height: 14px !important; }
      }
    `}</style>

    <div className="gcb">
      <a
        href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
        rel="noopener noreferrer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ffffff" viewBox="0 0 24 24">
          <path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" />
        </svg>
        9289 44 00 49
      </a>

      <span className="gcb-sep">|</span>

      <a href="tel:+919289440049">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#ffffff" viewBox="0 0 24 24">
          <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
        </svg>
        9289 44 00 49
      </a>

      <span className="gcb-hours">Mon-Sat (10:00 AM to 5:00 PM)</span>
    </div>
  </>
);

export default ContactBar;
